/** Shared product images & type options — mirrors quote form components */

import { getSelectOptionsForStep } from './productFieldOptions';

const PUBLIC = process.env.PUBLIC_URL || '';

export const BOXES_IMAGE_URL = `${PUBLIC}/boxes-hq.png`;
export const BAGS_IMAGE_URL = `${PUBLIC}/bags-hq.png`;
export const LABELS_IMAGE_URL = `${PUBLIC}/labels-hq.png`;
export const LABELSLAB_HEADER_IMAGE_URL = 'https://shipping-quote.labelslab.com/LabelsLab.png';
export const BOTTLE_MATERIAL_IMAGE_URL = 'https://shipping-quote.labelslab.com/Plastic-Recycling-Symbol.jpg';
export const BOTTLE_THREADING_IMAGE_URL = 'https://shipping-quote.labelslab.com/styles-v2.png';

export const BOX_TYPE_OPTIONS = [
  { value: '1', label: '#1 - Straight Tuck End Box (STE)' },
  { value: '2', label: '#2 - Reverse Tuck End Box (RTE)' },
  { value: '3', label: '#3 - Sleeve Box' },
  { value: '4', label: '#4 - Counter Display Box' },
  { value: '5', label: '#5 - Cylinder Box (Round Box)' },
  { value: '6', label: '#6 - 1-2-3 Bottom Box' },
  { value: '7', label: '#7 - Tuck Top Snap Lock Bottom Box' },
  { value: '8', label: '#8 - Gable Box' },
  { value: '9', label: '#9 - Display Box (With Steps)' },
  { value: '10', label: '#10 - Display Box' },
  { value: '11', label: '#11 - Shipping Boxes' },
  { value: '12', label: '#12 - Tray Box' },
  { value: '13', label: '#13 - Box with Lid' },
  { value: '14', label: '#14 - Rigid Box (Lift-off Lid)' },
  { value: '15', label: '#15 - Rigid Magnetic Closure Box' },
];

export const BAG_TYPE_OPTIONS = [
  { value: '1', label: '3 Side Sealed' },
  { value: '2', label: 'Stand Up with Bottom Gusset Without Zipper' },
  { value: '3', label: '3 Side Sealed with Zipper' },
  { value: '4', label: 'Stand Up with Bottom Gusset and Zipper' },
  { value: '5', label: 'Back Side Sealed' },
  { value: '6', label: 'Side Gusset Pouch' },
  { value: '7', label: 'Flat Bottom with Zipper' },
  { value: '8', label: 'Special Shape Bag' },
  { value: '9', label: 'Roll Film' },
  { value: '10', label: 'Spout Bag' },
  { value: '11', label: '2 Side Sealed' },
];

export const BLISTER_TYPE_OPTIONS = [
  { value: '1', label: 'Trapped Cardboard Blister' },
  { value: '2', label: 'Plastic Shell Blister' },
];

export const CAP_TYPE_OPTIONS = [
  { value: 'twistCap', label: 'Twist Cap' },
  { value: 'flipCap', label: 'Flip Cap' },
  { value: 'sprayCap', label: 'Spray Cap' },
  { value: 'pressCap', label: 'Press Cap' },
  { value: 'pumpCap', label: 'Pump Cap' },
  { value: 'dripper', label: 'Dripper' },
];

export const LABEL_SHAPE_OPTIONS = [
  { value: 'Circle', label: 'Circle' },
  { value: 'Oval', label: 'Oval' },
  { value: 'Rectangle', label: 'Rectangle' },
  { value: 'Square', label: 'Square' },
  { value: 'Special', label: 'Special' },
];

export const BOTTLE_MATERIAL_GROUP_OPTIONS = [
  { value: 'Aluminium', label: 'Aluminium' },
  { value: 'Glass', label: 'Glass' },
  { value: 'Plastic', label: 'Plastic' },
];

export const BOTTLE_MATERIAL_SUBGROUP_OPTIONS = [
  { value: 'LDPE', label: 'LDPE' },
  { value: 'PET', label: 'PET' },
  { value: 'PP', label: 'PP' },
  { value: 'HDPE', label: 'HDPE' },
];

export const BOTTLE_CAPACITY_OPTIONS = [
  '.5 Oz', '1 Oz', '2 Oz', '3 Oz', '4 Oz', '6 Oz', '8 Oz', 'Other',
].map((v) => ({ value: v, label: v }));

export const BOTTLE_COLOR_OPTIONS = [
  'Amber', 'Blue', 'Clear', 'Green', 'Natural', 'Silver (Aluminium)',
].map((v) => ({ value: v, label: v }));

export const BOTTLE_CAP_OPTIONS = [
  'Beer Bottle Caps', 'Dropper Caps', 'Spice & Sifter Caps', 'Bottle Pourer Caps',
  'Flip Top Caps', 'Spout Caps', 'Brush & Dauber Caps', 'Mister Caps',
  'Tamper-Evident Caps', 'Child-Resistant Capable Caps', 'Orifice Reducers',
  'Threaded & Lug Caps', 'Corks & Stoppers', 'Pump Caps', 'Trigger Sprayers',
  'Disc Caps', 'Shrink Bands & Cap Liners',
].map((v) => ({ value: v, label: v }));

export const BOTTLE_THREADING_OPTIONS = ['400', '410', '415', '425'].map((v) => ({ value: v, label: v }));

// Box materials by box type (from Boxes.js)
export const BOX_MATERIAL_OPTIONS_MAP = {
  '1': ['White cardboard', 'Silver cardboard', 'Kraft paper', 'Corrugated paper', 'Hologram Cardboard', 'CCNB (Clay Coated New Back)', 'SBS (Solid Bleached Sulfate)'],
  '2': ['White cardboard', 'Silver cardboard', 'Kraft paper', 'Corrugated paper', 'Hologram Cardboard', 'CCNB (Clay Coated New Back)', 'SBS (Solid Bleached Sulfate)'],
  '3': ['White cardboard', 'Silver cardboard', 'Kraft paper', 'Corrugated paper', 'Hologram Cardboard', 'CCNB (Clay Coated New Back)', 'SBS (Solid Bleached Sulfate)'],
  '4': ['White cardboard', 'Silver cardboard', 'Kraft paper', 'Corrugated paper', 'Hologram Cardboard', 'CCNB (Clay Coated New Back)', 'SBS (Solid Bleached Sulfate)'],
  '5': ['Rigid cardboard'],
  '6': ['White cardboard', 'Silver cardboard', 'Kraft paper', 'Corrugated paper', 'Hologram Cardboard', 'CCNB (Clay Coated New Back)', 'SBS (Solid Bleached Sulfate)'],
  '7': ['White cardboard', 'Silver cardboard', 'Kraft paper', 'Corrugated paper', 'Hologram Cardboard', 'CCNB (Clay Coated New Back)', 'SBS (Solid Bleached Sulfate)'],
  '8': ['White cardboard', 'Silver cardboard', 'Kraft paper', 'Hologram Cardboard', 'CCNB (Clay Coated New Back)', 'SBS (Solid Bleached Sulfate)'],
  '9': ['White cardboard', 'Silver cardboard', 'Kraft paper', 'Corrugated paper', 'Hologram Cardboard', 'CCNB (Clay Coated New Back)', 'SBS (Solid Bleached Sulfate)'],
  '10': ['White cardboard', 'Silver cardboard', 'Kraft paper', 'Corrugated paper', 'Hologram Cardboard', 'CCNB (Clay Coated New Back)', 'SBS (Solid Bleached Sulfate)'],
  '11': ['Corrugated paper'],
  '12': ['White cardboard', 'Silver cardboard', 'Kraft paper', 'Hologram Cardboard', 'CCNB (Clay Coated New Back)', 'SBS (Solid Bleached Sulfate)'],
  '13': ['Rigid cardboard'],
  '14': ['Rigid cardboard'],
  '15': ['Rigid cardboard'],
};

const OPTION_LOOKUP = {
  boxType: BOX_TYPE_OPTIONS,
  bagType: BAG_TYPE_OPTIONS,
  blisterType: BLISTER_TYPE_OPTIONS,
  capType: CAP_TYPE_OPTIONS,
  labelShape: LABEL_SHAPE_OPTIONS,
  bottleMaterialGroup: BOTTLE_MATERIAL_GROUP_OPTIONS,
  bottleMaterialSubGroup: BOTTLE_MATERIAL_SUBGROUP_OPTIONS,
  bottleCapacity: BOTTLE_CAPACITY_OPTIONS,
  bottleColor: BOTTLE_COLOR_OPTIONS,
  bottleCap: BOTTLE_CAP_OPTIONS,
  bottleThreading: BOTTLE_THREADING_OPTIONS,
};

/** Maps stored field keys (e.g. boxType) to option lists for display */
const FIELD_OPTION_LOOKUP = {
  boxType: BOX_TYPE_OPTIONS,
  bagType: BAG_TYPE_OPTIONS,
  blisterType: BLISTER_TYPE_OPTIONS,
  capType: CAP_TYPE_OPTIONS,
  shape: LABEL_SHAPE_OPTIONS,
  materialGroup: BOTTLE_MATERIAL_GROUP_OPTIONS,
  materialSubGroup: BOTTLE_MATERIAL_SUBGROUP_OPTIONS,
  capacity: BOTTLE_CAPACITY_OPTIONS,
  bottleColor: BOTTLE_COLOR_OPTIONS,
  bottleCap: BOTTLE_CAP_OPTIONS,
  threading: BOTTLE_THREADING_OPTIONS,
};

export function getProductOptions(step) {
  if (step?.productOptions?.length) return step.productOptions;
  const fieldOpts = getSelectOptionsForStep(step);
  if (fieldOpts?.length) return fieldOpts;
  if (step?.id && OPTION_LOOKUP[step.id]) return OPTION_LOOKUP[step.id];
  return null;
}

export function formatProductOptionLabel(stepId, value) {
  const options = OPTION_LOOKUP[stepId];
  if (!options) return String(value);
  const match = options.find((o) => o.value === String(value));
  return match ? match.label : String(value);
}

/** Human-readable label for a product.fields key/value (Quote Details, PDF, etc.) */
export function formatFieldDisplayValue(fieldKey, value) {
  if (value == null || value === '') return value;
  const options = FIELD_OPTION_LOOKUP[fieldKey];
  if (!options) return value;
  const match = options.find((o) => o.value === String(value));
  return match ? match.label : value;
}

export function getBoxMaterials(boxType) {
  return BOX_MATERIAL_OPTIONS_MAP[String(boxType)] || [];
}

export function getStepChatImages(step, draft) {
  if (!step) return [];
  const images = [];
  if (step.chatImage) {
    images.push({ url: step.chatImage, title: step.chatImageTitle || step.title });
  }
  if (step.extraChatImages?.length) {
    images.push(...step.extraChatImages);
  }
  if (step.id === 'bottleMaterialSubGroup') {
    images.push({ url: BOTTLE_MATERIAL_IMAGE_URL, title: 'Plastic material types' });
  }
  if (step.id === 'bottleThreading') {
    images.push({ url: BOTTLE_THREADING_IMAGE_URL, title: 'Threading styles' });
  }
  return images;
}

// Legacy box helpers for Boxes.js
export function formatBoxTypeLabel(number) {
  return formatProductOptionLabel('boxType', number);
}

export const BOX_TYPE_OPTIONS_LEGACY = BOX_TYPE_OPTIONS.map((o) => ({
  number: o.value,
  name: o.label.replace(/^#\d+\s*-\s*/, ''),
}));
